import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  insuranceproduct,
  Previousinsurer,
  quick_quotes,
  QuickQuote_Post,
  quick_quoteValues,
  GetPrevPolicy,
  SelectAddons,
  Compare_quote,
} from "../../Redux/actions/NumBikeation";
import { message } from "antd";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { Radio, Form, Row, Col, Select, Button, DatePicker } from "antd/lib";
import "./policySteps.css";
import { useHistory } from "react-router-dom";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import moment from "moment";
function PolicyStepsBike(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const vehicleDetails = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuickPost = useSelector((state) => state?.vehicledetail?.quoteInput);
  const PrevPolDetails = useSelector(
    (state) => state?.vehicledetail?.prevpolicydetail
  );
  const [product, setproduct] = useState([]);
  const [notExp, setnotExp] = useState(
    QuickPost?.currentPolicyExpired === "NotExpired"
      ? true
      : QuickPost?.currentPolicyExpired === "Expire Within 90 Days"
      ? true
      : QuickPost?.currentPolicyExpired === "Expired More Than 90 Days"
      ? true
      : false
  );
  const [CPExpired, setCPExpired] = useState(QuickPost?.currentPolicyExpired);
  const [bikenumDetails, setbikenumDetails] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNcb, setIsNcb] = useState(
    QuickPost?.isclaim ? QuickPost?.isclaim : false
  );

  const [selectedInsurer, setSelectedInsurer] = useState(
    PrevPolDetails?.prevInsurerName ? PrevPolDetails?.prevInsurerName : ""
  );
  const [NotSecure, setNotSecure] = useState(
    QuickPost?.insuranceProductCode === "Not_Secure" ? false : true
  );
  const [TPProduct, setTpProduct] = useState(QuickPost?.insuranceProductCode);
  // console.log('ncb...',isNcb)
  useEffect(() => {
    dispatch(Previousinsurer());
    dispatch(insuranceproduct())
      .then((res) => {
        setproduct(res);
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthenticated.") {
          dispatch({ type: "RESET_BIKE" });
          history.push("/");
        }
      });
  }, [dispatch]);

  // console.log("carnumDetails", bikenumDetails);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onChange = (e) => {
    // console.log("radio checked", e.target.value);
    // console.log(e.target.value);
    setTpProduct(e.target.value);
    if (e.target.value === "Not_Secure") {
      setNotSecure(false);
    } else if (e.target.value === "Bundled") {
      // setproductCode(e.target.value)
      setNotSecure(true);
    } else {
      setNotSecure(true);
    }
  };

  const disabledDate = (current) => {
    const currentDate = moment();
    const fiveMonthsFromNow = moment().add(25, "week");
    return (
      current &&
      (current < currentDate.endOf("day") ||
        current > fiveMonthsFromNow.endOf("day"))
    );
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    return today;
  };
  const handleDateChange = (date, dateString) => {
    // console.log(date);
    // console.log("dateString", dateString);
    setSelectedDate(dateString);
  };
  // console.log(selectedDate);

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const isuser = JSON.parse(localStorage.getItem("vibeUser"));
  const OnClaimchange = (e) => {
    // console.log(e.target.value)
    if (e.target.value === true) {
      setIsNcb(true);
    } else if (e.target.value === false) {
      setIsNcb(false);
    }
  };
  // console.log('NotSecure',NotSecure)

  const HandlePolicyEXP = (e) => {
    // console.log(e.target.value)
    if (e.target.value === "NotExpired") {
      setnotExp(true);
      setCPExpired("NotExpired");
    } else if (e.target.value === "Expire Within 90 Days") {
      setnotExp(true);
      setCPExpired("Expire Within 90 Days");
    } else if (e.target.value === "Expired More Than 90 Days") {
      setnotExp(true);
      setCPExpired("Expired More Than 90 Days");
    } else {
      setnotExp(false);
      setCPExpired("");
    }
  };

  const onFinish = (values) => {
    // console.log("values", values);
    // console.log(vehicleDetails?.varbike)
    const registrationDate = moment(values.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 5);
    const currentDate = new Date();
    const check = regDate > currentDate;
    console.log("check", check);
    const inputString = vehicleDetails?.varbike;
    const VarResult = inputString?.match(/^[^/]+/);
    // console.log(VarResult[0])
    //values.insuranceProductCode = check === false ? "TWP" : values.insuranceProductCode
    const productcode = values.insuranceProductCode;
    values.productCode =
      productcode === "Not_Secure"
        ? "TWT"
        : productcode === "Bundled"
        ? "TWS"
        : productcode;
    // console.log("productcode", productcode);

    // console.log(values);
    setLoading(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "TWS" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
            ? vechicleData?.insurance_policy_number
            : "0"
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "TWS" || productcode === "Bundled"
          ? values.previousInsurerCode
          : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "TWS" || productcode === "Bundled"
          ? moment(values.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "TWS" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    // console.log('ncbvalue',values?.ncbvalue)
    // console.log('isclaim',values?.isclaim)
    // console.log("currentTP",currentTP)
    let post = {
      currentPolicyExpired: values?.currentPolicyExpired,
      previousPolicyNumber:
        productcode === "Not_Secure"
          ? null
          : vechicleData?.insurance_policy_number
          ? vechicleData?.insurance_policy_number
          : "0",
      product_code:
        productcode === "Not_Secure"
          ? "TWT"
          : productcode === "Bundled"
          ? "TWS"
          : check === false
          ? "TWP"
          : productcode,
      policyHolderType: values?.PolicyHolderType,
      isVehicleNew: 0, //0 or 1 - Integer
      vehicle_core_code: vehicleDetails?.VehicleCoreCode,
      make: vehicleDetails?.make,
      model: vehicleDetails?.model,
      variant: VarResult[0],
      licensePlateNumber: auth?.bike_number,
      previousPolicyExpiryDate:
        productcode === "Not_Secure"
          ? moment(new Date()).format("YYYY-MM-DD")
          : moment(values.previousPolicyExpiryDate).format("YYYY-MM-DD"),
      registrationDate: moment(values.registrationDate).format("YYYY-MM-DD"),
      isPreviousInsurerKnown: productcode === "Not_Secure" ? 0 : 1, //0 r 1 int
      previousInsurerCode:
        productcode === "Not_Secure" ? null : values?.previousInsurerCode,
      isClaimInLastYear: values?.isclaim ? values?.isclaim : false,
      originalPreviousPolicyType:
        productcode === "TWS"
          ? "1OD_0TP"
          : productcode === "Bundled"
          ? "1OD_5TP"
          : null,
      originalPreviousPolicyTypeIcici:
        productcode === "Not_Secure"
          ? "TWT"
          : productcode === "Bundled"
          ? "Bundled"
          : productcode,
      // currentThirdPartyPolicy:
      //   productcode === "TWS" ? currentTP
      //   :productcode === "Bundled" ? currentTP
      //   : productcode === "TWS" && check === false ? null : null,
      currentThirdPartyPolicy:
        check === true && productcode === "TWS"
          ? currentTP
          : productcode === "Bundled"
          ? currentTP
          : check === false
          ? null
          : null,
      previousNoClaimBonus:
        values?.isclaim === true
          ? null
          : NotSecure === false
          ? null
          : values?.ncbvalue,
      pincode: "587316",
      isPOSP: is_POSP,
      insurance_id: auth.bike_insurance_id,
      returnToInvoice: false,
      consumables: false,
      partsDepreciation: false,
      engineProtection: false,
      roadSideAssistance: false,
      personalAccident: false,
      emergencyMedicalExpenses: false,
      // acc
      electrical: false,
      electricalinsuredamount: null,
      electricalminallowed: null,
      electricalmaxallowed: null,
      //
      nonElectrical: false,
      nonElectricalinsuredamount: null,
      nonElectricalminallowed: null,
      nonElectricalmaxallowed: null,
      //
      vehIDV: null,
      defaultIDV: null,
      minimumIDV: null,
      maximumIDV: null,
      //
      isTPPD: false,
      rimProtection: false,
      tyreProtection: false,
      personalBelonging: false,
      keyAndLockProtect: false,
      //
    };
    var Policydetails = {
      previousInsurerCode:
        productcode === "Not_Secure" ? null : values?.previousInsurerCode,
      prevInsurerName: selectedInsurer,
      previousPolicyNumber:
        productcode === "Not_Secure"
          ? null
          : vechicleData?.insurance_policy_number
          ? vechicleData?.insurance_policy_number
          : "",
      previousPolicyExpiryDate:
        productcode === "Not_Secure"
          ? moment(new Date()).format("YYYY-MM-DD")
          : moment(values.previousPolicyExpiryDate).format("YYYY-MM-DD"),
      currentThirdPartyPolicy:
        productcode === "TWS" || productcode === "Bundled" ? currentTP : null,
    };
    // console.log("v1/bike_insurance/quickquotes", post);
    setTimeout(() => {
      dispatch(QuickQuote_Post(post));
      dispatch(quick_quoteValues(values));
      dispatch(GetPrevPolicy(Policydetails));
      dispatch(SelectAddons([]));
      // dispatch(Compare_quote([]))
      setLoading(false);
      history.push("/planlayoutbike");
    }, 500);
  };

  return (
    <>
      <NavbarJourney />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 110px)" }}
      >
        <div className="container">
          <div className="mb-5">
            <h3>Fill Some Information Below So We Can Provide Exact Quote</h3>
          </div>
          <div className="row">
            <Form
              // layout={formLayout}
              form={form}
              style={{ width: "100%" }}
              requiredMark={false}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24}>
                <Col span={16}>
                  <div className="h6 text-blue mb-3 mb-3">
                    Previous Policy Type
                  </div>
                  <Form.Item
                    {...formItemLayout}
                    name="insuranceProductCode"
                    label="Policy Type"
                    className="form-item-bg"
                    rules={[
                      {
                        required: true,
                        message: "Please select Policy Type",
                      },
                    ]}
                    initialValue={QuickPost?.insuranceProductCode}
                  >
                    <Radio.Group
                      className="py-3 px-3 bg-white ant-radio-layout"
                      onChange={onChange}
                    >
                      {/* {product.map((e) => (
                        <Radio key={e.id} value={e.product_code}>
                          {e.product_name}
                        </Radio>
                      ))} */}
                      <Radio value="TWP">2W Comprehensive</Radio>
                      <Radio value="TWT">2W TP only</Radio>
                      <Radio value="TWS">2W SAOD</Radio>
                      <Radio value="Bundled">Bundled 1+5 Policy</Radio>
                      <Radio value="Not_Secure">Not Secure</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {NotSecure === true ? (
                  <>
                    <Col span={8}>
                      <div className="h6 text-blue mb-3">
                        Select previous insurer
                      </div>
                      <Form.Item
                        {...formItemLayout}
                        className="form-item-bg"
                        label="previous insurer"
                        name="previousInsurerCode"
                        rules={[
                          {
                            required: true,
                            message: "Please select previous insurer",
                          },
                        ]}
                        initialValue={QuickPost?.previousInsurerCode}
                      >
                        <Select
                          // defaultValue="Select your option"
                          placeholder="Select your option"
                          showSearch
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          options={props.preinslist?.map((p) => ({
                            key: p.id,
                            value: p.code,
                            label: p.name,
                          }))}
                          onChange={(value, option) => {
                            // console.log(value,option)
                            setSelectedInsurer(option?.label);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item
                        {...formItemLayout}
                        className="form-item-bg"
                        label="Have Your Current Policy Expired ?"
                        name="currentPolicyExpired"
                        rules={[
                          {
                            required: true,
                            message: "Please select Policy Expired",
                          },
                        ]}
                        initialValue={QuickPost?.currentPolicyExpired}
                      >
                        <Radio.Group
                          className="py-3 px-3 bg-white ant-radio-layout"
                          style={{ width: "100%" }}
                          onChange={(e) => HandlePolicyEXP(e)}
                          defaultValue={
                            notExp === true ? "NotExpired" : undefined
                          }
                        >
                          <Radio value="NotExpired">Not Expired</Radio>
                          <Radio value="Expire Within 90 Days">
                            Expire Within 90 Days
                          </Radio>
                          <Radio value="Expired More Than 90 Days">
                            Expired More Than 90 Days
                          </Radio>
                          <Radio value="I dont Remember">
                            I don't Remember
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {notExp === true ? (
                      <Col span={8}>
                        {/* <div className="h6 text-blue mb-3">Previous Policy Expiry Date</div> */}
                        <Form.Item
                          {...formItemLayout}
                          className="form-item-bg"
                          label="Previous Policy Expiry Date"
                          name="previousPolicyExpiryDate"
                          rules={[
                            {
                              required: true,
                              message: "Please select Date",
                            },
                          ]}
                          initialValue={
                            QuickPost?.previousPolicyExpiryDate
                              ? moment(QuickPost?.previousPolicyExpiryDate)
                              : null
                          }
                          // extra={isValid === false ? <p className="error-message">Date must be a future date</p> : ''}
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            // defaultValue={moment(bikeResult.insurance_upto)}
                            disabledDate={
                              CPExpired === "Expired More Than 90 Days"
                                ? null
                                : disabledDate
                            }
                            onChange={handleDateChange}
                            defaultPickerValue={getDefaultPickerValue()}
                            format="YYYY-MM-DD"
                            placeholder="Select Expiry Date"
                          />
                        </Form.Item>
                      </Col>
                    ) : null}
                  </>
                ) : null}
                <Col span={8}>
                  {notExp === true || NotSecure === false ? (
                    <div className="h6 text-blue mb-3">Registration Date</div>
                  ) : null}
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    label="Registration Year"
                    name="registrationDate"
                    initialValue={moment(vehicleDetails.year)}
                    rules={[
                      {
                        required: true,
                        message: "Please select Registration Year",
                      },
                    ]}
                  >
                    <DatePicker
                      disabled
                      style={{ width: "100%" }}
                      format="YYYY-MM-DD"
                      placeholder="Select Registration Year"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <div className="h6 text-blue mb-3">Policy Holder Type</div>
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    name="PolicyHolderType"
                    label="Vehicle Owned By ?"
                    rules={[
                      {
                        required: true,
                        message: "Please select PolicyHolderType",
                      },
                    ]}
                    initialValue={
                      QuickPost?.PolicyHolderType
                        ? QuickPost?.PolicyHolderType
                        : "INDIVIDUAL"
                    }
                  >
                    <Radio.Group
                      className="py-3 px-3 bg-white ant-radio-layout"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Radio value="INDIVIDUAL">Individual</Radio>
                      <Radio value="COMPANY">Company</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <div className="h6 text-blue mb-3">Licence Validity</div>
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    label="Do You Have Valid Driving Licence ?"
                    name="driverlicence"
                    rules={[
                      {
                        required: true,
                        message: "Please select",
                      },
                    ]}
                    initialValue={
                      QuickPost?.driverlicence
                        ? QuickPost?.driverlicence
                        : "Yes"
                    }
                  >
                    <Radio.Group
                      className="py-3 px-3 bg-white ant-radio-layout"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <div className="h6 text-blue mb-3">PA Cover</div>
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    label="Previous PA Cover of Rs 15 Lakh ?"
                    name="paCover"
                    rules={[
                      {
                        required: !NotSecure ? false : true,
                        message: "Please select",
                      },
                    ]}
                    initialValue={
                      QuickPost?.paCover ? QuickPost?.paCover : "No"
                    }
                  >
                    <Radio.Group
                      disabled={!NotSecure}
                      className="py-3 px-3 bg-white ant-radio-layout"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <div className="h6 text-blue mb-3">Owner Change</div>
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    label="Owner Change in Last 12 Month ?"
                    name="ownerChange"
                    rules={[
                      {
                        required: !NotSecure ? false : true,
                        message: "Please select",
                      },
                    ]}
                    initialValue={
                      QuickPost?.ownerChange ? QuickPost?.ownerChange : "No"
                    }
                  >
                    <Radio.Group
                      disabled={!NotSecure}
                      className="py-3 px-3 bg-white ant-radio-layout"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {TPProduct === "TWT" ? null : (
                  <>
                    <Col span={8}>
                      <div className="h6 text-blue mb-3">Claim</div>
                      <Form.Item
                        {...formItemLayout}
                        className="form-item-bg"
                        label="Claim Made In Expiry Policy"
                        name="isclaim"
                        rules={[
                          {
                            required: !NotSecure ? false : true,
                            message: "Please select",
                          },
                        ]}
                        initialValue={
                          QuickPost?.isclaim ? QuickPost?.isclaim : false
                        }
                      >
                        <Radio.Group
                          disabled={!NotSecure}
                          className="py-3 px-3 bg-white ant-radio-layout"
                          style={{
                            width: "100%",
                          }}
                          onChange={OnClaimchange}
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    {NotSecure === true ? (
                      <>
                        {isNcb === false ? (
                          <Col span={8}>
                            <div className="h6 text-blue mb-3">
                              Previous No Claim Bonus (NCB)
                            </div>
                            <Form.Item
                              {...formItemLayout}
                              className="form-item-bg"
                              label="Previous No Claim Bonus(NCB)"
                              name="ncbvalue"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select",
                                },
                              ]}
                              initialValue={
                                QuickPost?.ncbvalue ? QuickPost?.ncbvalue : null
                              }
                            >
                              <Select placeholder="NCB">
                                <Select.Option value={0}>0%</Select.Option>
                                <Select.Option value={20}>20%</Select.Option>
                                <Select.Option value={25}>25%</Select.Option>
                                <Select.Option value={35}>35%</Select.Option>
                                <Select.Option value={45}>45%</Select.Option>
                                <Select.Option value={50}>50%</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        ) : null}
                      </>
                    ) : null}
                  </>
                )}
              </Row>
              <div
                className="bg-white position-sticky bottom-0"
                style={{ height: "50px" }}
              >
                <div className="d-flex align-items-center justify-content-end container text-right py-2">
                  <p className="mb-0 mx-3">
                    By proceeding, you agree to the Terms & Conditions
                  </p>
                  <Form.Item className="mb-0" {...buttonItemLayout}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Get Quotes
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PolicyStepsBike);
